<template lang="pug">
section
    .flex-row
        el-form-item.grow(:label="$t('Name')" prop="name")
            el-input(type="text" v-model="name")
        el-form-item.key-field.grow(:label="$t('Key')" prop="key")
            el-input(type="text" v-model="form.key")
                //- template(v-slot:prefix)
                    span ?marketing-campaign=
        el-form-item.key-field.grow(v-if="campaignGetParameterFeatureEnabled" :label="$t('GET Parameter')")
            el-input(type="text" disabled :value="`?marketing-campaign=${encodeURIComponent(form.key)}`")
        el-form-item.colorpicker(:label="$t('Color')" prop="color")
            el-color-picker(
                v-model="form.color"
                ref="colorpicker"
                color-format="hex"
                @active-change="updateSecondaryColorPreview"
                @change="clearSecondaryColorPreview"
            )
            el-tooltip(effect="dark" :content="$t('Product page')" placement="bottom")
                .secondary-color-preview(:style="{ 'background-color': secondaryColor }")
    el-form-item.no-margin(:label="$t('Description')" prop="description")
        quill-editor(v-model="form.description" :options="quillConfig")
</template>

<i18n>
{
    "de": {
        "Key": "Eindeutige Kennung",
        "Name": "Name",
        "Color": "Farbe",
        "Description": "Beschreibung"
    }
}
</i18n>

<script>

import _ from 'lodash'
import Color from 'color'
import { useSetupStore, useMarketingCampaignStore } from '@/stores'

import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(de)

import quillConfig from '@/quill/config'

export default {
    name: 'Main',
    data() {
        return {
            quillConfig,
            secondaryColorPreview: undefined,
        }
    },
    computed: {
        campaignStore() {
            return useMarketingCampaignStore()
        },
        form() {
            return this.campaignStore.form
        },
        name: {
            get() {
                return _.get(this.form, 'name', '')
            },
            set(value) {
                this.form.name = value
                if (!this.form.id) {
                    this.form.key = _.kebabCase(value)
                }
            }
        },
        secondaryColor() {
            if (this.secondaryColorPreview) {
                return this.secondaryColorPreview
            }
            return this.getSecondaryColor(this.form.color)
        },
        campaignGetParameterFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return features.includes('marketing-campaign-get-parameter');
        },
        setupStore() {
            return useSetupStore()
        },
        activeCms() {
            return this.setupStore.activeCms
        },
    },
    methods: {
        updateSecondaryColorPreview(string) {
            const rgbToHex = string => {
                const rgb = string.split("(")[1].split(")")[0].split(",").map(el => parseInt(el));
                return '#' + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1)
            };
            this.secondaryColorPreview = this.getSecondaryColor(rgbToHex(string));
        },
        clearSecondaryColorPreview() {
            this.secondaryColorPreview = undefined
        },
        getSecondaryColor(hex) {
            let color = Color(hex)
            return color
                // .lighten(0.35)
                // .desaturate(0.5)
                // .rotate(20)
                .fade(0.5)
                // .fade(0.5)
                .rgb()
                .string()
        }
    },
    // mounted() {
    //     console.log(this.$refs.colorpicker)
    // }
}
</script>

<style lang="sass" scoped>
.flex-row
    display: flex
    justify-content: space-between
    .grow
        flex-grow: 1
        margin-right: 1rem
    .el-form-item:last-child
        margin-right: 0

.secondary-color-preview
    width: 36px
    height: 36px
    background: red
    display: inline-block
    border-radius: 4px
    border: 1px solid rgb(230, 230, 230)
    width: 24px
    height: 24px
</style>
